/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanyUserNotification } from './CompanyUserNotification';
import {
    CompanyUserNotificationFromJSON,
    CompanyUserNotificationFromJSONTyped,
    CompanyUserNotificationToJSON,
} from './CompanyUserNotification';

/**
 * 
 * @export
 * @interface CompanyUserNotificationsData
 */
export interface CompanyUserNotificationsData {
    /**
     * 新しい通知の件数
     * @type {number}
     * @memberof CompanyUserNotificationsData
     */
    unreadCount: number;
    /**
     * 
     * @type {Array<CompanyUserNotification>}
     * @memberof CompanyUserNotificationsData
     */
    notifications: Array<CompanyUserNotification>;
}

/**
 * Check if a given object implements the CompanyUserNotificationsData interface.
 */
export function instanceOfCompanyUserNotificationsData(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "unreadCount" in value;
    isInstance = isInstance && "notifications" in value;

    return isInstance;
}

export function CompanyUserNotificationsDataFromJSON(json: any): CompanyUserNotificationsData {
    return CompanyUserNotificationsDataFromJSONTyped(json, false);
}

export function CompanyUserNotificationsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyUserNotificationsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'unreadCount': json['unread_count'],
        'notifications': ((json['notifications'] as Array<any>).map(CompanyUserNotificationFromJSON)),
    };
}

export function CompanyUserNotificationsDataToJSON(value?: CompanyUserNotificationsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'unread_count': value.unreadCount,
        'notifications': ((value.notifications as Array<any>).map(CompanyUserNotificationToJSON)),
    };
}

